import { h } from 'preact';
import { SlotsRemainingBadge } from '../SlotsRemainingBadge';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'SlotsRemainingBadge',
  category: '🏷️ Badges & Indicadores',
  description: 'Indicador de vagas restantes com 3 níveis de urgência',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <SlotsRemainingBadge max={100} current={20} />
      <SlotsRemainingBadge max={100} current={85} />
      <SlotsRemainingBadge max={100} current={97} />
    </div>
  ),
};
